import React from 'react';
import Link from 'next/link';
import Utils from '../../libs/utils';
import { Section as Styled, Link as StyledLink } from '../../styles/about';

/**
 * トピックのクリップの説明
 */
interface Props {
  isSp: boolean;
  isGuest: boolean;
}

const SectionClip: React.FC<Props> = props => {
  const { isSp, isGuest } = props;
  const href = isGuest ? Utils.createAuhorizeUrl('/my') : '/my';

  return (
    <Styled>
      <h2 className="icon-clip">
        <span>
          お気に入りのトピックを
          {isSp && <br />}
          保存しておきたい！というときは…
        </span>
      </h2>
      <p>
        <strong>クリップ</strong>
        をしておけばOK！あなたのマイページですぐチェックできます☆
      </p>
      <StyledLink>
        <Link href={href}>
          <a className="text-blue-400 underline text-sm">マイページへ</a>
        </Link>
      </StyledLink>
    </Styled>
  );
};

export default SectionClip;
